import {onUnmounted, ref, watch} from 'vue';
import {useRoute} from 'vue-router';
import {useDisplayMobile} from '@malt/utils';

export function useOrganizationSettingsMobileNavbar() {
    const route = useRoute();
    const {isDisplayMobile} = useDisplayMobile();
    const isMobileOpen = ref(false);

    function openMobileNavbar() {
        isMobileOpen.value = true;
    }

    function closeMobileNavbar() {
        isMobileOpen.value = false;
    }

    watch([isMobileOpen, isDisplayMobile], ([open, mobile]) => {
        if (import.meta.client) {
            document.body.style.overflow = open && mobile ? 'hidden' : '';
        }
    });

    watch(
        () => route.fullPath,
        () => {
            if (isMobileOpen.value) {
                closeMobileNavbar();
            }
        },
    );

    watch(isDisplayMobile, (mobile) => {
        if (!mobile) {
            isMobileOpen.value = false;
        }
    });

    onUnmounted(() => {
        if (import.meta.client) {
            document.body.style.overflow = '';
        }
    });

    return {
        isDisplayMobile,
        isMobileOpen,
        openMobileNavbar,
        closeMobileNavbar,
    };
}
